interface IBillManagementIconProps {
  className?: string;
}

/**
 * Stylized invoice — outlined document with a header bar (provider) and three
 * line items underneath, the bottom-right line truncated to suggest a total.
 * The metaphor is "an invoice you can fix": clear hierarchy, scannable rows.
 * Monoline, `currentColor`, no fills. Designed on a 48×48 grid.
 */
const BillManagementIcon = ({ className }: IBillManagementIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* invoice paper */}
    <path d="M11 6 h26 v36 l-4 -3 l-4 3 l-4 -3 l-4 3 l-4 -3 l-4 3 l-2 -1.5 V6 z" />
    {/* provider header bar */}
    <path d="M16 13 h16" strokeLinecap="square" />
    {/* line items */}
    <path d="M16 21 h11" strokeLinecap="square" />
    <path d="M30 21 h2" strokeLinecap="square" />
    <path d="M16 27 h11" strokeLinecap="square" />
    <path d="M30 27 h2" strokeLinecap="square" />
    {/* subtotal divider */}
    <path d="M16 32 h16" strokeLinecap="square" />
    {/* total row, right-aligned */}
    <path d="M22 36 h10" strokeLinecap="square" />
  </svg>
);

export default BillManagementIcon;
